module.exports = __webpack_public_path__ + "static/15-1e28d9f3dc3b78e9f787f2fe244c98a4.jpg";